export default __webpack_public_path__ + "media/images/app-icon-cf3f6d441bf091d97fc3da9e7606c97e.svg";